import { forwardRef, type ComponentProps } from 'react'
import { Dialog as BaseDialog } from '@base-ui/react/dialog'
import { twMerge } from 'tailwind-merge'
import { Interactive } from '../../interactive'
import { DIALOG_POPUP_CLASS_NAME, useAutofocusTarget, useHeightEasing, usePopupRef } from './popup-behavior'

export interface DialogPopupProps extends ComponentProps<typeof BaseDialog.Popup> {
  className?: string
}

export const DialogPopup = forwardRef<HTMLDivElement, DialogPopupProps>(function DialogPopup(
  { className, children, initialFocus, ...props },
  forwardedRef,
) {
  const { ref, setRef } = usePopupRef(forwardedRef)
  const autofocusTarget = useAutofocusTarget(ref)
  useHeightEasing(ref)

  return (
    <BaseDialog.Popup
      ref={setRef}
      initialFocus={initialFocus ?? autofocusTarget}
      className={twMerge(DIALOG_POPUP_CLASS_NAME, className)}
      {...props}
    >
      {/* The overlay window is click-through outside registered bounds, and a
          centered dialog sits outside the panel's. Without this its close
          button falls through to the app behind the overlay. */}
      <Interactive>{children}</Interactive>
    </BaseDialog.Popup>
  )
})
